const styleOverrides = {
  root: {
    fontSize: '17px',
    fontWeight: 'bold',
    textAlign: 'center'
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiAlertTitle.js.map